import { rgba } from './color.js';

const tau = Math.PI * 2;

/** Soft halo hugging the sphere's edge, breathing, with a slow rim highlight. */

export function createGlow() {
  function renderHalo(context, frame, strength) {
    const { width, height, radius, time, energy, settings } = frame;
    const x = width / 2;
    const y = height / 2;
    const breath = 0.5 + 0.5 * Math.sin(time * 1.4);
    const spread = radius * (0.1 + 0.1 * energy + 0.04 * breath);
    const halo = context.createRadialGradient(x, y, radius - spread, x, y, radius + spread * 1.8);

    halo.addColorStop(0, rgba(settings.glow, 0));
    halo.addColorStop(0.35, rgba(settings.glow, 0.5 * strength));
    halo.addColorStop(1, rgba(settings.glow, 0));
    context.fillStyle = halo;
    context.fillRect(0, 0, width, height);
  }

  function renderRim(context, frame, strength) {
    const { width, height, radius, time, energy, settings } = frame;
    const x = width / 2;
    const y = height / 2;
    const rim = context.createConicGradient(time * 0.6, x, y);

    rim.addColorStop(0, rgba(settings.accent, 0));
    rim.addColorStop(0.15, rgba(settings.accent, 0.9 * strength));
    rim.addColorStop(0.32, rgba(settings.accent, 0));
    rim.addColorStop(0.6, rgba(settings.glow, 0.5 * strength));
    rim.addColorStop(0.78, rgba(settings.glow, 0));
    rim.addColorStop(1, rgba(settings.accent, 0));

    context.lineWidth = radius * 0.015 * (1 + energy);
    context.strokeStyle = rim;
    context.shadowColor = rgba(settings.accent, strength);
    context.shadowBlur = radius * 0.08;
    context.beginPath();
    context.arc(x, y, radius, 0, tau);
    context.stroke();
    context.shadowBlur = 0;
  }

  return {
    resize() {},
    setState() {},
    destroy() {},

    render(context, frame) {
      const strength = frame.settings.intensity * (0.35 + frame.energy * 0.65);

      renderHalo(context, frame, strength);
      renderRim(context, frame, strength);
    },
  };
}
